import styled from 'styled-components';
const HeaderLogoTextStyle = styled.h1 `
  margin: 0;
  font-weight: 700;
  display: flex;
  justify-content: normal;
  align-items: center;
  flex-shrink: 1;
  box-sizing: content-box;
`;
export default HeaderLogoTextStyle;
//# sourceMappingURL=HeaderLogoTextStyle.js.map